import { Component } from '@angular/core';

import { BehaviorSubject, of } from 'rxjs';

import { CamContactService } from '@camelot/services';
import {
  CAM_AUTH_TOKEN,
  CamPermissionsService,
  CamUsersService,
  GuardComponent,
  InputChoiceTemplateComponent,
  LoginCardComponent,
  MenuUserComponent,
  MyAccountComponent,
  SwitchLanguageComponent,
  SwitchLanguageCtaComponent,
  TenantUrlDisplayerComponent,
  UserMyProfileComponent,
  UserProfileCardComponent,
  UserProfileComponent,
} from '@camelot/user';

import { TestIdDirective } from '@camelot/testing-harness';

const userMock = {
  firstName: 'Jane',
  id: 'user-1',
  lastName: 'Doe',
  mail: 'jane@example.com',
  tenantInformations: [],
};

const authServiceMock = {
  fetchUserProfile: () => of(null),
  firstLetter: 'J',
  isAuthenticated$: of(false),
  load: () => void 0,
  login: () => void 0,
  logout: () => Promise.resolve(null),
  trigram: 'JD',
  user$: new BehaviorSubject(null),
  userProfile$: new BehaviorSubject(null),
};

const permissionsServiceMock = {
  canAccess$: () => of(true),
  canDirectAccess: () => true,
  isAuthenticated: true,
};

const usersServiceMock = {
  currentUser: { get$: () => of(userMock) },
  fetchCurrentUser$: () => of(userMock),
  fetchUser$: () => of(userMock),
  fetchUsers$: () => of([userMock]),
  user: { get$: () => of(userMock) },
  users: { get$: () => of([userMock]) },
};

const contactServiceMock = {
  contactTenantRoute: { get$: () => of('https://tenant.example/contact') },
  fetchContactTenantRoute$: () => of('https://tenant.example/contact'),
};

@Component({
    imports: [
        GuardComponent,
        InputChoiceTemplateComponent,
        LoginCardComponent,
        MenuUserComponent,
        MyAccountComponent,
        SwitchLanguageComponent,
        SwitchLanguageCtaComponent,
        TenantUrlDisplayerComponent,
        TestIdDirective,
        UserMyProfileComponent,
        UserProfileCardComponent,
        UserProfileComponent,
    ],
    providers: [
        { provide: CAM_AUTH_TOKEN, useValue: authServiceMock },
        { provide: CamPermissionsService, useValue: permissionsServiceMock },
        { provide: CamUsersService, useValue: usersServiceMock },
        { provide: CamContactService, useValue: contactServiceMock },
    ],
    template: `
    <cam-guard camTestId="cam-guard" level="read" feature="e2e">guarded content</cam-guard>
    <cam-login-card camTestId="cam-login-card" />
    <cam-user-menu camTestId="cam-user-menu" />
    <cam-my-account camTestId="cam-my-account" />
    <cam-user-my-profile camTestId="cam-user-my-profile" />
    <cam-switch-language camTestId="cam-switch-language" />
    <cam-switch-language-cta camTestId="cam-switch-language-cta" />
    <cam-tenant-url-displayer camTestId="cam-tenant-url-displayer" contactId="contact-1" />
    <cam-user-profile camTestId="cam-user-profile" [user]="this.user" />
    <cam-user-profile-card camTestId="cam-user-profile-card" userId="user-1" />
    <app-input-user-choice-template camTestId="app-input-user-choice-template" />
  `
})
export class UserCase {
  public user = userMock;
}
